import { Directive, forwardRef } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

@Directive({
  selector: '[validateBirthday]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => BirthdayValidatorDirective),
      multi: true,
    },
  ],
})
export class BirthdayValidatorDirective implements Validator {
  validate(control: AbstractControl): ValidationErrors | null {
    const birthday : Date = control.value;
    // DateUtilsBS clear to UTC-Time, but the user normally uses local time
    // so clear to midnight of localtime.
    let midnight: Date = new Date();
    midnight.setHours(0,0,0,0);
    return birthday >= midnight ? { 'invalidBirthday': true } : null;
  }
}

